module.exports = __webpack_public_path__ + "img/总览.e7acae74.svg";